module.exports = __webpack_public_path__ + "img/HORLOGE_COLONNE_GRILLE_DE_POINTAGE.48abc467.svg";